
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route, NavigationGuardNext } from 'vue-router';
import { loginEducacionContinua } from '@/assets/api/matricula';
import TabsInformacion from '@/componentes/UI/TabsInformacion.vue';
import HeaderPrincipal from "@/componentes/UI/HeaderPrincipal.vue";

@Component({
  components: {
    HeaderPrincipal,
    TabsInformacion
  }
})
export default class Inicio extends Vue {
  rut = '';
  clave = '';
  error = '';

  @Watch('clave')
  cambioNumero() {
    this.clave = this.clave.replace(/[^0-9]/, '');
  }

  login() {
    // Hacer logout antes de intentar login
    this.$store.commit('logout');
    // Limpiar formato del RUT para envío
    // const rutLimpio = this.rut.replace(/[^0-9kK]/g, '');
    loginEducacionContinua({ rut: this.rut, clave: this.clave })
      .then((data) => {
        this.$store.commit('loginPostulanteEduCont', data);
        this.$nextTick();
        this.$router.push({ name: 'educontinua bienvenida' });
      })
      .catch((error) => {
        this.error = error.mensaje;
      });
  }
}
